export const actionCopyDe = {
    next: "Weiter",
    back: "Zurück",
    save: "Speichern",
    send: "Senden",
    skip: "Überspringen",
    skipForNow: "Ich weiß es noch nicht",
    continue: "Weiter",
    cancel: "Abbrechen",
    delete: "Löschen",
    submit: "Absenden",
    confirm: "Bestätigen",
    add: "Hinzufügen",
    edit: "Bearbeiten",
    done: "Fertig",
    stop: "Beenden",
    retry: "Erneut versuchen",
    download: "Herunterladen",
    apply: "Anwenden",
    filter: "Filter",
    filters: "Filter",
    columns: "Spalten",
    close: "Schließen",
    search: "Suchen",
    more: "Mehr",
    none: "Keine",
    previous: "Zurück",
    rename: "Umbenennen",
    duplicate: "Duplizieren",
    share: "Teilen",
    clearAll: "Alle löschen",
    clearSearch: "Suche löschen",
    loading: "Wird geladen...",
    open: "Öffnen",
    invite: "Einladen",
    saveCorrection: "Korrektur speichern",
    saving: "Speichern...",
    sending: "Wird gesendet...",
    submitting: "Wird abgesendet...",
    skipping: "Wird übersprungen...",
    goingBack: "Zurück...",
    goingNext: "Weiter...",
    cancelling: "Wird abgebrochen...",
    deleting: "Wird gelöscht...",
    deleteConfirmTitle: "Sind Sie absolut sicher?",
    deleteConfirmDescription: "Diese Aktion kann nicht rückgängig gemacht werden.",
    continuing: "Weiter...",
    confirming: "Wird bestätigt...",
    adding: "Wird hinzugefügt...",
    editing: "Wird bearbeitet...",
    finishing: "Wird abgeschlossen...",
    stopping: "Wird beendet...",
    retrying: "Wird wiederholt...",
    downloading: "Wird heruntergeladen...",
};
